export class ServiceRequestModel {
    public ServiceRequestID: number;
    public CommunityID: number;
    public CommunityLotId: number;
    public RequestTypeLookupID: number;
    public IsImportant: boolean;
    public Notes: string;
    public RequestNo: string;
    public BuyerID: number;
    public RequestStatus: string;
    public CoordinatorID: number;
    public OpenDate: string;
    public OpenDateString: string;
    public OpenFormattedDate: string;
    public CloseDate: string;
    public Status: string;
    public Description: string;
}


// WEBPACK FOOTER //
// ./src/app/models/ServiceRequestModel.ts